import React from 'react';

const userList = ({userList}) => {
    return (
        <ul>
            {
                userList.map((u) => {
                    return (
                      <li key={u.uname}>
                        { u.uname }
                       </li>
                    )
                })
            }
        </ul>
    )
}
export default userList;


// WEBPACK FOOTER //
// ./src/components/chat/UserList.js